export const getBlobData = (blob: Blob, callback: (data: string) => void) => {
  // Transform the file into a readable image
  const reader = new FileReader()
  reader.addEventListener('load', event => {
    const data = event.target?.result as string
    callback(data)
  })
  reader.readAsDataURL(blob)
}
